import { typeContactEnum, typeSocieteEnum } from '../../../enums/typeContactEnum'

export const CONTACT_PROSPECT = [
	typeContactEnum.LEAD_RESIDENTIEL,
	typeContactEnum.CLIENT_POTENTIEL_RESIDENTIEL,
	typeSocieteEnum.SOCIETE_LEAD_RESIDENTIEL,
	typeSocieteEnum.SOCIETE_CLIENT_POTENTIEL_RESIDENTIEL
]

export const CONTACT_CLIENT = [
	typeContactEnum.CLIENT_RESIDENTIEL,
	typeSocieteEnum.SOCIETE_CLIENT_RESIDENTIEL
]